import React from 'react';
import { motion } from 'framer-motion';
export function CallToAction() {
  return <section className="py-24 px-6" data-id="element-9">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="max-w-5xl mx-auto bg-gradient-to-br from-peach to-coral rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden shadow-soft-lg" data-id="element-10">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-11">
          <motion.div animate={{
          rotate: 360
        }} transition={{
          repeat: Infinity,
          duration: 20,
          ease: 'linear'
        }} className="absolute -top-20 -left-20 w-64 h-64 bg-white/10 rounded-full blur-2xl" data-id="element-12" />
          <motion.div animate={{
          rotate: -360
        }} transition={{
          repeat: Infinity,
          duration: 25,
          ease: 'linear'
        }} className="absolute -bottom-32 -right-32 w-96 h-96 bg-white/10 rounded-full blur-3xl" data-id="element-13" />
        </div>

        <div className="relative z-10" data-id="element-14">
          <div className="flex justify-center gap-4 mb-8" data-id="element-15">
            {['🐶', '🐱', '🐰', '🐹', '🦜'].map((emoji, i) => <motion.div key={i} initial={{
            y: 20,
            opacity: 0
          }} whileInView={{
            y: 0,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="w-12 h-12 md:w-16 md:h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-2xl md:text-3xl shadow-sm border border-white/30" data-id="element-16">
                {emoji}
              </motion.div>)}
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight" data-id="element-17">
            Ready to start your journey?
          </h2>
          <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-18">
            Join thousands of pet lovers who are building better habits and
            taking care of themselves — together with their best friends.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-19">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto px-8 py-4 rounded-full font-bold text-coral bg-white hover:bg-cream shadow-lg flex items-center justify-center gap-2" data-id="element-20">
              Download for iOS
            </motion.button>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto px-8 py-4 rounded-full font-bold text-white bg-warmBrown/20 hover:bg-warmBrown/30 backdrop-blur-sm border border-white/20 shadow-lg flex items-center justify-center gap-2" data-id="element-21">
              Download for Android
            </motion.button>
          </div>
        </div>
      </motion.div>
    </section>;
}